// 금액 자 — 견적·계약·변경공사·부가세가 한 벌을 쓴다(두 벌이면 한쪽만 막는 자리가 생긴다).

import { subjectJosa, topicJosa } from "../../lib/josa";

// 금액이 셀 수 있는 범위를 넘었다 — 부르는 쪽은 문구가 아니라 이 타입으로 가른다.
export class MoneyRangeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MoneyRangeError";
  }
}

/**
 * 금액이 셀 수 있는 수인가. 아니면 여기서 멈춘다.
 *
 * 자바스크립트 정수는 `Number.MAX_SAFE_INTEGER` 까지만 정확하다. 넘어가면 덧셈이
 * 조용히 틀리고, `Infinity`·`NaN` 은 「0보다 큰가」 같은 검사를 전부 통과해
 * **그대로 발송된다** — 고객이 총액 `NaN` 인 견적서를 받는다.
 *
 * 한 칸에 자릿수를 잘못 넣은 것이 대부분이라, 저장을 막고 되돌려 보내는 편이
 * 이상한 수가 굳는 것보다 낫다.
 */
export const checked = (value: number, what: string): number => {
  if (!Number.isSafeInteger(value)) {
    throw new MoneyRangeError(
      `${what}${subjectJosa(what)} 셀 수 있는 범위를 넘었습니다 — 수량·단가의 자릿수를 확인해 주세요`
    );
  }
  return value;
};

/**
 * 원 단위 금액인가. 음수·소수·`NaN`·`Infinity` 를 여기서 막는다.
 *
 * `checked` 만으로는 부족하다 — 음수는 안전정수라 통과하는데 `0019` 의
 * `>= 0` check 에 가서야 걸린다. 저장까지 가기 전에 돌려보낸다.
 */
export const checkedMoney = (value: number, what: string): number => {
  checked(value, what);
  if (value < 0) {
    throw new Error(`${what}${topicJosa(what)} 0 이상이어야 합니다`);
  }
  return value;
};
